import { Component, input } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'lumio-icon',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <lucide-icon
      [name]="name()"
      [size]="size()"
      [class]="iconClass()"
    />
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
})
export class IconComponent {
  /** Nome do ícone (ex: flame, home, user) */
  name = input.required<string>();
  /** Tamanho em pixels */
  size = input<number>(24);
  /** Classe CSS adicional */
  iconClass = input<string>('');

}
